import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { SkeletonValue } from 'modules/finance/components/FinancialWorkspace/components/SkeletonValue'

interface Props {
  loading: boolean
  count: number
}

export const Headcount = ({ loading, count }: Props) => {
  return (
    <Box
      flexDirection="column"
      gap="s16"
      padding="s16"
      border={{
        all: {
          style: 'solid',
          width: 's1',
          color: 'grey400',
        },
      }}
      borderRadius={{
        all: 'abs016',
      }}
      style={{
        width: '50%',
      }}
    >
      <Text.Normal size="200" weight="medium" caps>
        {i18n.t('finance.financial_workspace.employee_costs.workforce.hc')}
      </Text.Normal>
      <Text.Normal size="400" weight="bold" caps>
        {loading ? <SkeletonValue /> : count}
      </Text.Normal>
    </Box>
  )
}
